import { render, staticRenderFns } from "./fotter.vue?vue&type=template&id=3259ba9e&scoped=true"
import script from "./fotter.vue?vue&type=script&lang=js"
export * from "./fotter.vue?vue&type=script&lang=js"
import style0 from "./fotter.vue?vue&type=style&index=0&id=3259ba9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3259ba9e",
  null
  
)

export default component.exports